module.exports = __webpack_public_path__ + "c36ce3984238f9f39d225b96447f6520.png";